import styled from "@emotion/styled";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

export const ContentTextAreaContainer = styled.div<{
  minHeight?: string;
  maxHeight?: string;
  backgroundColor?: string;
  borderColor?: string;
}>`
  min-height: 100px;
  width: 100%;
  border: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.borderColor || withVar(DesignToken.BorderBasicPrimary)
    };
  line-height: 20px;
  padding: 8px 10px;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: ${withVar(RadiusToken.Radius3)};
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.backgroundColor
  };

  #rich-text-area {
    min-height: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.minHeight ? props.minHeight : "240px")
    };
    max-height: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.maxHeight
    };
    overflow-y: auto;

    p {
      margin: 0;
    }

    ol {
      list-style: decimal;
      margin: 10px 20px;
    }

    ul {
      list-style: disc;
      margin: 10px 20px;
    }

    li {
      margin: initial;
      padding: initial;
      line-height: 1.4;
    }

    img {
      max-width: 100%;
      height: auto;
      image-orientation: from-image;
    }

    img.hd-image {
      max-width: 460px;
      height: auto;
    }

    @media (max-width: ${ResponsiveBreakpoint.Mobile}px) {
      img.hd-image {
        max-width: 230px;
        height: auto;
      }
    }
  }

  a {
    text-decoration: underline;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.linkColor
    };
  }

  h1 {
    font-size: 18px;
    font-weight: bold;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
  }
`;

export const ToolbarContainer = styled.div<{ wrap?: boolean }>`
  margin-top: 0.25em;
  display: flex;
  flex-flow: row nowrap;
  flex-wrap: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.wrap ? "wrap" : "nowrap")
  };
  align-items: center;
  align-self: flex-end;

  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    align-self: center;
  }
`;
